/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description:  ShareTotalCapacity component for the Impact Evaluation Dashboard
Author: Deimos Space UK

Version: 1.0
*/
import React from "react";
import { Card, CardBody } from "reactstrap";
import Spinner from 'react-bootstrap/Spinner';

export default function ShareTotalCapacity({ loading, data }) {
  return (
    <Card className="widget-flat ">
      <CardBody>
        <i
          className="mdi mdi-speedometer float-right"
          style={{ fontSize: "2.5rem", color: '#003247' }}
        ></i>
        <h6 className="text-uppercase mt-0">SHARE OF TOTAL CAPACITY</h6>
        <p className="mb-0 text-muted">
          <span className="text-nowrap">[%]</span>
        </p>
        {loading && <Spinner animation="border" />}
        {!loading &&
          <>
            <div style={{ display: 'flex', flexDirection: 'row', width: '100%', gap: 20 }}>
              <div style={{ width: '50%' }}>
                <h2 className="my-2" id="active-users-count">{data?.total_capacity}</h2>
              </div>
            </div>

          </>
        }


      </CardBody>
    </Card>
  );
}
